import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { VariationOptionGroup } from 'ish-core/models/product-variation/variation-option-group.model';

@Component({
  selector: 'ish-product-variation-select-swatch',
  templateUrl: './product-variation-select-swatch.component.html',
  styleUrls: ['./product-variation-select-swatch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class ProductVariationSelectSwatchComponent {
  readonly group = input.required<VariationOptionGroup>();

  readonly changeOption = output<{
    group: string;
    value: string;
  }>();

  optionChange(group: string, value: string) {
    this.changeOption.emit({ group, value });
  }
}
